import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ErrorMessage, Field } from "formik";
import $ from "jquery";
import moment from "moment";

import { selectNrOfRooms, setApartmentData, addSecurityDoor, setInsuranceStart, selectPayment } from "../../reducers/apartmentAction";
import NumberOfRooms from "../../JSON/NumberOfRooms";

import calendar from "../../assets/icons/calendar-20.svg";

class ApartmentInputCard extends Component {

  selectNrOfRooms(rooms) {
    this.props.selectNrOfRooms(rooms);
    this.props.setFieldValue("rooms", rooms);
  }

  selectPayment(payment) {
    this.props.selectPayment(payment);
    this.props.setFieldValue("selected_payment_method", payment);
  }

  componentDidMount() {
    let self = this;

    var date = new Date();
    var today = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    var expireDate = new Date();
    expireDate.setMonth(expireDate.getMonth() + 12);

    $(".datepicker").datetimepicker({
      format: "YYYY-MM-DD",
      locale: "sv",
      allowInputToggle: true,
      minDate: today,
      maxDate: expireDate,
      date: new Date(this.props.values.insuranceStart)
    });

    // Set a correct active state for the button
    $(".datepicker").on("dp.show", function() {
      $("#datetimepicker .bootstrap-datetimepicker-widget").attr(
        "aria-hidden",
        "true"
      );
      $(".datepicker button").addClass("active");
    });

    $(".datepicker").on("dp.hide", function() {
      $(".datepicker button").removeClass("active");
    });

    $(".datepicker").on("dp.change", function(e) {
      let dateString = moment(e.date).format("YYYY-MM-DD");
      self.props.setFieldValue("insuranceStart", dateString);
      self.props.setInsuranceStart(dateString);
    });
  }

  render() {

    let fieldNeeded = "*";
    if(this.props.customer == "false") {
      fieldNeeded = "";
    }
    
    const securityDoor = (this.props.showSecurityDoor) ? (<div className="col-md-6">
      <div className="form-group">
        <label><h2>&nbsp;</h2></label>
        <div className="custom-control custom-checkbox mr-1">
          <input
            type="checkbox"
            className="custom-control-input"
            onChange={() => this.props.addSecurityDoor( !this.props.security_door ) }
            id="checkboxSecuriyDoor"
            checked={this.props.security_door}
          />
          <label className="custom-control-label" htmlFor="checkboxSecuriyDoor">
            Säkerhetsdörr finns (ger 10% rabatt)
          </label>
          <Field name="security_door" type="hidden" className="form-control" />
        </div>
      </div>
    </div>) : "";
    
    const paymentSelection = this.props.paymentSelection.length > 1 ? (<div className="col-md-8">
    <div className="form-group">
      <label htmlFor="selectPayment">Betalningssätt*</label>
      <div className="dropdown" id="custom-select" tabIndex="0">
        <div type="text" className={ "custom-select-dd" + (this.props.errors.selected_payment_method && this.props.touched.selected_payment_method ? " is-invalid" : "") } id="selectPayment" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" >
          <span>
            {this.props.values.selected_payment_method ? this.props.values.selected_payment_method.value : "Välj betalningssätt"}
          </span>
        </div>
        <Field name="selected_payment_method" type="hidden" className={ "form-control" + (this.props.errors.selected_payment_method && this.props.touched.selected_payment_method ? " is-invalid" : "") } />
        <ErrorMessage name="selected_payment_method" component="div" className="invalid-feedback" />

        <div className="dropdown-menu custom-dropdown" aria-labelledby="selectPayment" >
          {this.props.paymentSelection.map(ps => (
            <div className="dropdown-item" onClick={() => this.selectPayment(ps)} key={ps.key} >
              {ps.value}
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>) : "";
  
    return (
      <div>
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="basic-addon2">
                    Bostadsrättsförening/Hyresvärd {fieldNeeded}
                  </label>
                  <div className="input-group">
                    <Field name="landlord" type="text"
                      onBlur={e => {
                        // call the built-in handleBur
                        this.props.handleBlur(e);
                        this.props.setApartmentData({ landlord: e.target.value });
                      }}
                      className={
                        "form-control" +
                        (this.props.errors.landlord && this.props.touched.landlord ? " is-invalid" : "")
                      }
                    />
                    <ErrorMessage name="landlord" component="div" className="invalid-feedback" />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                    <label htmlFor="selectNrOfRooms">Antal rum{fieldNeeded}</label>
                  <div className="dropdown" id="custom-select" tabIndex="0">
                    <div type="text" className={ "custom-select-dd" + (this.props.errors.rooms && this.props.touched.rooms ? " is-invalid" : "") } id="selectNrOfRooms" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" >
                      <span>
                        {this.props.values.rooms ? this.props.values.rooms.name : "Välj rum"}
                      </span>
                    </div>
                    <ErrorMessage name="rooms" component="div" className="invalid-feedback" />

                    <div className="dropdown-menu custom-dropdown" aria-labelledby="selectNrOfRooms" >
                      {NumberOfRooms.map(nrrooms => (
                        <div className="dropdown-item" onClick={() => this.selectNrOfRooms(nrrooms)} key={nrrooms.key} >
                          {nrrooms.name}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label>Försäkringen ska börja gälla *</label>

                  <div className="input-group datepicker" id="datetimepicker2">
                    <input type="text" id="datetimepicker2-input" className="form-control" placeholder="åååå-mm-dd" required="" />
                    <span className="input-group-append">
                      <button className="btn" type="button" tabIndex="-1">
                        <img src={calendar} alt="" />
                      </button>
                    </span>
                  </div>
                  <Field
                    name="insuranceStart"
                    type="hidden"
                    className={ "form-control" + (this.props.errors.insuranceStart && this.props.touched.insuranceStart ? " is-invalid" : "") }
                  />
                  <ErrorMessage name="insuranceStart" component="div" className="invalid-feedback" />
                </div>
              </div>
              
              { securityDoor }
              
              { paymentSelection }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    apartment_information: state.apartmentReducer.apartment_information,

    landlord: state.apartmentReducer.landlord,
    rooms: state.apartmentReducer.apartment_information.number_of_rooms,
    selected_number_of_rooms: state.apartmentReducer.apartment_information.selected_number_of_rooms,
    security_door: state.apartmentReducer.apartment_information.security_door,
    insurance_start: state.apartmentReducer.apartment_information.insurance_start,
    
    comprehensive_insurance: state.apartmentReducer.apartment_information.comprehensive_insurance,
    increased_travel_protection: state.apartmentReducer.apartment_information.increased_travel_protection,
    personal_accident_insurance: state.apartmentReducer.apartment_information.personal_accident_insurance,
    tenant_insurance: state.apartmentReducer.apartment_information.tenant_insurance,

    showSecurityDoor: state.simpleReducer.textSections.securityDoor,
    customerSection: state.simpleReducer.customerSection,
    paymentSelection: state.simpleReducer.textSections.paymentSelection,
    selected_payment_method: state.apartmentReducer.apartment_information.selected_payment_method
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setApartmentData: bindActionCreators(setApartmentData, dispatch),
    selectNrOfRooms: bindActionCreators(selectNrOfRooms, dispatch),
    addSecurityDoor: bindActionCreators(addSecurityDoor, dispatch),
    setInsuranceStart: bindActionCreators(setInsuranceStart, dispatch),
    selectPayment: bindActionCreators(selectPayment, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ApartmentInputCard);
